export type ErrorsType = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  getQEPError: (parameters: Record<any, any>) => QEPErrorConstructor;
  QEPError: QEPErrorType;
  QEPNetworkError: QEPNetworkErrorType;
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export type QEPErrorType = {
  message: string;
  name: string;
  time: Date;
  params?: {
    [key: string]: any;
    localNotification: boolean;
  };
  isNetworkError?: boolean;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  toJSON: () => {
    name: string;
    message: string;
    stacktrace?: string;
    time: Date;
  };
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export type QEPNetworkErrorType = QEPErrorType;

// eslint-disable-next-line @typescript-eslint/naming-convention
type QEPErrorConstructor = new (message: string, parameters?: Record<any, any>) => QEPErrorType;
